// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/Supplier.yaml
// Generated: 2026-07-08T12:37:01.813Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateSupplier, UpdateSupplier, Supplier } from '@/types/procurement/Supplier';

/**
 * Supplier Service
 * CRUD operations for Supplier via the ABP API.
 */
export const supplierService = new EntityService<Supplier, CreateSupplier, UpdateSupplier>(
  '/api/procurement/supplier',
  'Supplier',
);
